<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content *ngIf="isLoading">Loading Data, Please Wait...</div>
<div mat-dialog-content *ngIf="!isLoading">
  <form class="edit-interactive-subscription-dialog-form">
    <mat-form-field>
      <mat-label>Name (required, unique, 40 character max)</mat-label>
      <input
        matInput
        name="data.interactSubTypeName"
        [(ngModel)]="data.interactSubTypeName"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Description (required)</mat-label>
      <input
        matInput
        name="data.description"
        [(ngModel)]="data.description"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Interactives (min 1 required)</mat-label>
      <mat-select name="selectedInteractive" [(ngModel)]="selectedInteractive">
        <mat-option
          *ngFor="let interactive of data.interactives"
          [value]="interactive"
          >{{ interactive.interactName }}</mat-option
        >
      </mat-select> </mat-form-field
    ><br />
    <ng-container>
      <button mat-raised-button color="primary" (click)="onAddInteractive()">
        Add
      </button> </ng-container
    ><br />
    <mat-form-field>
      <mat-chip-list #interactiveChipLIst>
        <mat-chip
          *ngFor="let isb of data.appliedInteractives"
          [removable]="removable"
          (removed)="onRemoveInteractive(isb)"
        >
          Interact: {{ isb.interactName }}
          <mat-icon matChipRemove>x</mat-icon>
        </mat-chip>
      </mat-chip-list> </mat-form-field
    ><br />
    <ng-container>
      <button mat-raised-button color="primary" (click)="editLicense()">
        Edit License
      </button> </ng-container
    ><br />
    <mat-form-field>
      <mat-label>Restrict purchase to following emails:</mat-label>
      <input
        matInput
        name="ToAddEmail"
        [(ngModel)]="ToAddEmail"
      /> </mat-form-field
    ><br />
    <ng-container>
      <button mat-raised-button color="primary" (click)="addRestrictedEmail()">
        Add Email
      </button> </ng-container
    ><br />
    <mat-form-field>
      <mat-chip-list #restrictedEmailChipLIst>
        <mat-chip
          *ngFor="let isb of data.restrictPurchaseEmails"
          [removable]="removable"
          (removed)="onRemoveEmail(isb)"
        >
          {{ isb }}
          <mat-icon matChipRemove>x</mat-icon>
        </mat-chip>
      </mat-chip-list> </mat-form-field
    ><br />
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Subscription
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
